/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from 'react';

import Markdown from '../../common/Markdown/Markdown';
import NoTagRenderer from '../../common/NoTagRenderer/NoTagRenderer';
import { TBackground, addBackground } from '../../core/helpers';
import './FAQ.css';
import FAQItem from './FAQItem/FAQItem';

interface IProps {
  title?: string;
  desc?: string;
  side?: 'left' | 'right';
  items: {
    question: string;
    answer: string;
  }[];
  background?: TBackground;
}

function FAQ({ title, desc, side, items, background }: IProps) {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const handleToggle = useCallback((i: number) => {
    setOpenIdx((prevState) => (prevState === i ? null : i));
  }, []);

  return (
    <section
      className={`faq${side === 'left' ? ' faq--left' : ''}${background ? ' section-bg' : ' section'}`}
      {...addBackground({ img: undefined, gradient: background })}
    >
      <div className="wrap wrap--lg">
        <div className="faq__container">
          {!title && !desc ? null : (
            <div className="faq__header">
              {!title ? null : (
                <h2 className="faq__title h3">
                  <Markdown
                    components={{
                      p: NoTagRenderer,
                    }}
                  >
                    {title}
                  </Markdown>
                </h2>
              )}
              {!desc ? null : <Markdown className="faq__desc markdown">{desc}</Markdown>}
            </div>
          )}
          <div className="faq__questions">
            {items.map((item, i) => (
              <FAQItem
                item={item}
                isOpen={openIdx === i}
                i={i}
                handleToggle={handleToggle}
                key={item.question}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;
